/**
 * 判断当前环境是否为微博环境
 * @returns {boolean} 如果是微博环境返回 true，否则返回 false
 * @example
 * ```ts
 * isInWeibo(); // => true (在微博内)
 * isInWeibo(); // => false (在浏览器中)
 * ```
 */
export function isInWeibo(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  return /\bweibo\b/i.test(ua);
}
